import styles from './ToggleRadioButtons.module.scss';

type Props = {
  options: { label: string; value: string; name: string }[];
  handleOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  activeOption: string;
};

const ToggleRadioButtons = ({ options, handleOnChange, activeOption }: Props) => {
  return (
    <div className={styles.container}>
      {options.map(option => {
        return (
          <div className={styles.optionContainer} key={option.value}>
            <input
              aria-label={option.label}
              aria-controls="gift-card-type-selection"
              value={option.value}
              onChange={handleOnChange}
              className={styles.radioButton}
              id={option.value}
              name={option.name}
              type="radio"
              checked={activeOption === option.value}
            />
            <label htmlFor={option.value} className={styles.label}>
              <div className={styles.innerLabel}>{option.label}</div>
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default ToggleRadioButtons;
